module.exports = __webpack_public_path__ + "img/arrow-2.adbfba35.png";